import { Css, TabsWithContent, TabWithContent } from "@homebound/beam";
import { useHistory, useLocation } from "react-router-dom";
import { LoadingBoundary } from "src/components/LoadingBoundary";
import { PageHeader } from "src/components/PageHeader";
import { useDocumentTitle } from "src/hooks/useDocumentTitle";
import { UwConfigType } from "./UwConfigEndpoints";
import { UwConfigHistory } from "./UwConfigHistory";
import { UwConfigTable } from "./UwConfigTable";
import { UW_CONFIG_TYPES } from "./uwConfigFields";

type TabValue = UwConfigType | "history";

/** Admin page for the configs that drive underwriting: legacy ready plans, costs & metrics and amenity adjustments */
export function UwConfigPage() {
  useDocumentTitle("Underwriting Config");
  const history = useHistory();
  const location = useLocation();

  // the selected tab lives in the URL so changes can link straight to a config
  const tabParam = new URLSearchParams(location.search).get("tab");
  const tabs: TabWithContent<TabValue>[] = [
    ...UW_CONFIG_TYPES.map((typeDef) => ({
      name: typeDef.label,
      value: typeDef.type,
      render: () => (
        <LoadingBoundary useProgressBar>
          <UwConfigTable typeDef={typeDef} />
        </LoadingBoundary>
      ),
    })),
    {
      name: "History",
      value: "history",
      render: () => (
        <LoadingBoundary useProgressBar>
          <UwConfigHistory />
        </LoadingBoundary>
      ),
    },
  ];
  const selected = tabs.find((t) => t.value === tabParam)?.value ?? tabs[0].value;

  return (
    <div data-testid="uwConfigPage">
      <PageHeader title="Underwriting Config" />
      <div css={Css.px3.pb3.$}>
        <TabsWithContent
          tabs={tabs}
          selected={selected}
          onChange={(tab) => history.replace({ search: `?tab=${tab}` })}
        />
      </div>
    </div>
  );
}
